/**
 * Resolves the default member role for newly assigned facilities.
 */

import { FacilityInfo, RbacRoleId } from "../types";

/**
 * Returns the least-privileged member role appropriate for a facility dashboard.
 *
 * @param facility - Facility metadata loaded for the super-admin workflow
 * @returns Clinical Trials role for Clinical Trials tenants, otherwise the standard medical role
 */
export function getDefaultFacilityRole(
  facility: FacilityInfo | undefined,
): RbacRoleId.CLINICAL_TRIALS_USER | RbacRoleId.STANDARD_MED_ONC {
  return facility?.dashboardType === "clinical_trials"
    ? RbacRoleId.CLINICAL_TRIALS_USER
    : RbacRoleId.STANDARD_MED_ONC;
}
